

enum FormState {
    ADD = 'ADD',
    CREATE = 'Create',
    UPDATE = 'Update',
    EDIT = 'EDIT',
    DELETE = 'DELETE',
    VIEW = 'VIEW',
}

enum RouteState {
    UPDATE = 'update', 
    CREATE = 'create',
    VIEW = 'view',
}

export { FormState, RouteState };